<template>
  <v-container fluid>
    <!-- CONTENTS -->
    <v-row class="pa-2">
      <v-col
        sm="12"
        md="4"
        lg="3"
        xl="2"
      >
        <players-container
          :players-item="playersItem"
          @playerSelected="playerSelectedChanged"
        />
      </v-col>
      <v-col
        sm="12"
        md="8"
        lg="9"
        xl="10"
      >
        <GmapMap
          ref="sharerMap"
          :center="centerMap"
          :zoom="zoomMap"
          map-type-id="terrain"
          class="status-map"
          :options="{
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: true,
          }"
          @click="isInfoShown = false"
        >
          <GmapMarker
            v-for="(marker, index) in playerList"
            :key="index"
            :position="marker.position"
            :clickable="true"
            :draggable="false"
            :icon="{ url: url(marker.problems) }"
            :title="marker.name"
            @click="marker.isInfoShown = clickInfo(marker)"
          >
            <GmapInfoWindow
              :opened="marker.isInfoShown"
              :options="{
                content:
                  '<span class=\'iconTitle\'></span>' +
                  '<span> </span>' +
                  '<span class=\'icon\'>' +
                  marker.name +
                  '</span>' +
                  '<br/><br/>' +
                  '<span class=\'iconNetwork\'></span>' +
                  '<span style=\'color:black\'> ' +
                  $t('status.last-connection') +
                  ' : ' +
                  marker.lastConnection +
                  '</span>' +
                  '<br/><br/>' +
                  '<span class=\'iconUpdate\'></span>' +
                  '<span style=\'color:black\'> ' +
                  $t('status.last-update') +
                  ' : ' +
                  marker.lastUpdate +
                  '</span>',
              }"
              @closeclick="marker.isInfoShown = false"
            />
          </GmapMarker>
        </GmapMap>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import playersContainer from "./AsunaPage/PlayersContainer";

// Connectors
import { PlayerConnector } from "../Database/PlayerConnector";

// Libs
import { gmapApi } from "vue2-google-maps";
const md5 = require("md5");

export default {
  components: {
    playersContainer,
  },
  data() {
    return {
      playerConnector: new PlayerConnector(this.$store.state.user),
      centerMap: { lat: 47.0, lng: 2.0 },
      playerSelected: [],
      playerList: [],
      playersItem: [],
      bounds: null,
      zoomMap: 6,
    };
  },
  computed: {
    google: gmapApi,
  },
  created() {
    document.title = this.$t("akito.supervision") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("akito.supervision"));
  },
  mounted() {
    // ADMIN CHECKING
    if (md5(this.$store.state.user.aikido) != "bc4634dcd9303d59bace805e02472bcd") {
      this.$store.dispatch("disconnect");

      if (this.$router.history.current.fullPath != "/") {
        this.$router.push({ path: "/" });
      }
    }

    this.getAllPlayers();
  },
  methods: {
    clickInfo(marker) {
      if (marker !== undefined) {
        if (marker.isInfoShown !== undefined) {
          for (let i = 0; i < this.playerList.length; i++) {
            if (marker.id != this.playerList[i].id) {
              this.playerList[i].isInfoShown = false;
            }
          }
          return !marker.isInfoShown;
        }
      }
    },
    playerSelectedChanged(val) {
      this.playerSelected = val;
      this.selectMarker(this.playerSelected);
    },
    selectMarker(itemSelected) {
      this.playerList.forEach((player) => {
        if (itemSelected.length > 0) {
          if (player.name == itemSelected[0].name) {
            player.isInfoShown = true;
          } else {
            player.isInfoShown = false;
          }
        } else {
          player.isInfoShown = false;
        }
      });
    },
    url() {
      return require("../../assets/icon/pin.png");
    },
    getAllPlayers() {
      this.playerConnector
        .getAllPlayers()
        .then((players) => {
          // TODO: format in db server
          this.playerList = players.map((element) => {
            return {
              id: element.id_plyr,
              name: element.name,
              position: {
                lat: parseFloat(element.lat),
                lng: parseFloat(element.lng),
              },
              isInfoShown: false,
              lastUpdate: element.last_update,
              lastConnection: element.last_connect,
              problems: [
                {
                  name: "connected",
                  icon: "map-marker-check",
                },
              ],
            };
          });

          this.initMap();

          // Construct treeview object
          let id_tree = 1;

          players.forEach((element) => {
            Object.assign(element, { id: id_tree });
            id_tree++;
          });

          this.playersItem = [
            {
              children: players,
              id: 0,
              name: this.$t("dialog.all"),
            },
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    autoZoom() {
      if (this.bounds) {
        this.$refs.sharerMap.fitBounds(this.bounds);
      }
    },
    initMap() {
      this.$gmapApiPromiseLazy().then(() => {
        // eslint-disable-next-line no-undef
        this.bounds = new google.maps.LatLngBounds();

        this.playerList.forEach((element) => {
          this.bounds.extend({
            lat: parseFloat(element.position.lat),
            lng: parseFloat(element.position.lng),
          });
        });

        this.$refs.sharerMap.panToBounds(this.bounds);
        this.autoZoom();
      });
    },
  },
};
</script>

<style>
.icon {
  color: black;
  font-size: 20px;
  font-weight: bold;
}

.iconTitle:before,
.iconNetwork:before,
.iconUpdate:before {
  content: "";

  width: 1.5em;
  height: 1.5em;

  margin-right: 0.2em;
  display: inline-block;

  background-size: cover;
}

.iconTitle:before {
  background-image: url("../../assets/icon/tag.png");
}

.iconNetwork:before {
  background-image: url("../../assets/icon/check-network.png");
}

.iconUpdate:before {
  background-image: url("../../assets/icon/update.png");
}

.status-map {
  width: 100%;
  height: 100%;
}
</style>
